<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FRxE0o/media/FC-9781528938587.jpg?1695340671542" alt="This image is the cover for the book Rorkk’s Captive"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rorkk’s Captive
      </h1>
      <p class="bookDescription body article font2">
        <p>Rorkk is a Rotari Admiral who has defended his planet against Krylan invasion for most of his adult life. Shattered by his former fiancé’s betrayal and tired of defending a planet under siege, his spirit is almost broken until intelligence is received that the Krylans are targeting an Earth woman for her unique genome to enhance their Nzumbe troops. Seizing the opportunity to thwart the Krylans and obtain important intelligence information, Rorkk embarks on a risky mission to ensure the Earthling does not fall into the wrong hands. Instead of finding her dream job on Aero Space Nine with the Galactic Trading Academy, Aurora discovers her role as Chief Engineer, Spacecraft Maintenance embroils living and working on a rust bucket plagued by mechanical problems, ageing maintenance droids and a crew of oddball geeks just out of school. After surviving a micro meteor storm which compromises the space station’s hull and the environmental systems bringing the crew to the brink of disaster, Aurora visits Robodome, an off-world pleasure centre to unwind. Aurora’s life changes overnight when she visits the centre and is kidnapped. One minute she’s about to enjoy the delights of her assigned pleasure bot, the next, she finds herself locked in a cabin on an alien spacecraft. With a journey that threatens everything they believed about themselves and enemies at every turn, Rorkk and Aurora must join forces to defeat the enemy. Can they learn to trust each other, their growing attraction and stop the Krylans in their tracks?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda LaBrooy
      </h2>
      
      <p class="authorDescription body article">Amanda LaBrooy lives in Darwin in the tropical north of Australia with her husband, two grown sons and Turbo the dog. To satisfy her desire for adventure and to escape the corporate world, she enjoys creating stories with strong characters. In her spare time, she can be found curled up with a good book or at the gym throwing weights around, trying to look like a pro.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?573c0852